import { render, staticRenderFns } from "./ChapterWaiverBanner.vue?vue&type=template&id=441c2529&scoped=true&"
import script from "./ChapterWaiverBanner.vue?vue&type=script&lang=js&"
export * from "./ChapterWaiverBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChapterWaiverBanner.vue?vue&type=style&index=0&id=441c2529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c2529",
  null
  
)

export default component.exports